import React, { useState, useEffect } from 'react';
import DistrictServices from '../services/DistrictServices';
import useAsync from '../hooks/useAsync';
import PincodeStatus from './TogelButton/PincodeStatus';
import Modal from 'react-modal';
import PincodeUpdate from './Update Model/UpdatePincode';
import { useNavigate, useLocation, Link } from 'react-router-dom';

Modal.setAppElement('#root');

function Pincode() {
  const location = useLocation(); 
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const cityId = searchParams.get('id');
  const [pincodeData, setPincodeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [canGoBack, setCanGoBack] = useState(false);
  const [isCityView, setIsCityView] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
   const [activeIndex, setActiveIndex] = useState(null);

  const { data, run } = useAsync(DistrictServices.getPincodes);

  useEffect(() => {
    setCanGoBack(window.history.length > 1);
    const pathSegments = location.pathname.split("/");
    setIsCityView(pathSegments.includes("city"));
  }, [location.pathname]);


  const fetchPincode = async () => {
    try {
      setIsLoading(true);
      const response = await DistrictServices.getPincodes(cityId);
      setPincodeData(response?.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (cityId) {
      fetchPincode();
    }
  }, [cityId]);

  const filteredData = pincodeData.filter(pincode =>
    pincode.code.toLowerCase().includes(searchQuery.toLowerCase())
  );


   const handleEditDetails = (pincode) => {
    setSelectedEdit(pincode);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

   const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };


   const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };



  return (
    <>
      <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

<div className="my-auto">

  <h5 className="page-title fs-21 mb-1"> Pincode List <span className="badge bg-orange">{filteredData?.length || 0}</span></h5>
  <nav>

    <ol className="breadcrumb mb-0">

      <li className="breadcrumb-item">
        <a href="javascript:void(0);">Home</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
        Description
      </li>
    </ol>
  </nav>
</div>
<div className="d-flex my-xl-auto right-content align-items-center">

  <div className="pe-1 mb-xl-0">

    <div className="sub-title-box-right d-flex">

    <Link className="round-add-btn" to={`/add-pincode?id=${cityId}`}>
                                  <img src="img/plus.svg" alt="Add Cities" />
    </Link>

    {canGoBack && (
          <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
            Back
          </button>
        )}
        <button className="btn refreshbutton me-2" onClick={() => window.location.reload()}>
          Refresh
        </button>
    </div>
  </div>



</div>
</div>
      
        <div className="container-box px-0 pt-2">
        <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    className='form-control'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>
    
          <div className="container-box-inner table-reponsive-tabe">
            {isLoading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <table id="example" className="table table-striped" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Area</th>
                    <th>Pincode</th>
                    <th>Status</th>
                    <th>Action</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((pincode, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{pincode?.area}</td>
                      <td>{pincode?.code}</td>
                      <td className="status-toggle">
                        <PincodeStatus pincode={pincode} page="Pincode" onSuccess={fetchPincode} />
                      </td>


                       <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(pincode)}>Edit</button>
                              </li>
                             
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                      
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="Pincode Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <PincodeUpdate data={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
    </>
  );
}

export default Pincode;
